import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { adminApi } from '../api/admin.api'

export function useAdminUsers(search?: string, isSuspended?: boolean, page = 1) {
  return useQuery({
    queryKey: ['admin', 'users', { search, isSuspended, page }],
    queryFn: () => adminApi.getUsers({ search, is_suspended: isSuspended, page }),
  })
}

export function useAdminUserMutations() {
  const qc = useQueryClient()
  const invalidate = () => qc.invalidateQueries({ queryKey: ['admin', 'users'] })

  return {
    suspend: useMutation({ mutationFn: adminApi.suspendUser, onSuccess: invalidate }),
    reactivate: useMutation({ mutationFn: adminApi.reactivateUser, onSuccess: invalidate }),
    delete: useMutation({ mutationFn: adminApi.deleteUser, onSuccess: invalidate }),
    forceReset: useMutation({ mutationFn: adminApi.forcePasswordReset }),
    exportData: useMutation({ mutationFn: adminApi.exportUser }),
  }
}
